
//import storage from 'redux-persist/lib/storage';

const loginInt = {
    loginDetails: {},
    applicationDetails: {},
    currentTabDetails: ''

}

function LoginReducer(state = loginInt, action) {
    //console.log('action',action );
    switch (action.type) {
        case "SHOW_LOGIN_DETAILS":
            return {
                ...state, 
                isLoggedIn: true,
                loginDetails: action.payload,
                
            }
        case "SHOW_APPLICATION_DETAILS":
            return { ...state, applicationDetails: action.payload };
        case "SET_CURRENT_TAB_DETAILS":
            return { ...state, currentTabDetails: action.payload };

        // case "USER_LOGOUT": {  
        //     // for all keys defined in your persistConfig(s)
        //     //console.log('in reducers logout');
        //     window.sessionStorage.removeItem('token');
        //     //storage.removeItem('persist:root');
        //     // storage.removeItem('persist:otherKey')
        //     //return Reducers(undefined, action);
        // }
       
          case "USER_LOGOUT":
            return {
              ...state,
              isLoggedIn: false,
             
            };
        
         
        default:
            return state;

    }
}
export default LoginReducer;
